(function () {
    'use strict';
    var controllerId = 'profiloDocente';
    angular.module('app').controller(controllerId, ['$scope', '$rootScope', 'datacontext', '_', 'common', '$uibModalInstance', 'docente', '$translate', profiloDocenteFn]);

    function profiloDocenteFn($scope, $rootScope, datacontext, _, common, $uibModalInstance, docente, $translate) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var logError = getLogFn(controllerId, "logError");
        var logSuccess = getLogFn(controllerId, "logSuccess");
                
        $scope.docente = docente;
        $scope.amicizia = null;        
        
        datacontext.community_getAmicizia($scope.docente.Id).then(function (amicizia) {
            datacontext.materia_getAllByDocenteId($scope.docente.Id).then(function (materie) {
                datacontext.classe_getAllByDocenteId($scope.docente.Id).then(function (classi) {               
                    $scope.docente.classi = _.uniq(classi, 'Grado');
                });
                $scope.docente.materie = materie;
            });
            $scope.amicizia = amicizia;            
        });

        $scope.richiediAmicizia = function () {
            datacontext.community_addAmicizia($scope.docente.Id).then(function (data) {
                if(data && data.Id) {
                    logSuccess($translate.instant('RichiestaInoltrata'));
                    $scope.amicizia = data;
                    $uibModalInstance.close();
                }
                else 
                    logError($translate.instant('ErroreElaborazioneRichiesta'));
            });
        };

        $scope.annullaRichiesta = function () {
            datacontext.community_deleteAmicizia($scope.amicizia.Id).then(function (data) {                
                if (data == '200'){
                    logSuccess($translate.instant('RichiestaAnnullata'));
                    $scope.amicizia = null;
                    $uibModalInstance.close();                    
                }                    
                else
                    logError($translate.instant('ErroreElaborazioneRichiesta'));
            });
        }

        $scope.accettaAmicizia = function () {            
            datacontext.community_accettaAmicizia($scope.amicizia.Id).then(function (data) {
                if (data && data.Id) {
                    logSuccess($translate.instant('AmiciziaAccettata'));
                    $scope.amicizia = data;
                    $uibModalInstance.close();

                    $rootScope.richiesteCount = 0;
                    datacontext.community_getAllRichieste(0).then(function (data) {
                        $rootScope.richiesteCount = data.length;
                    });
                }
                else
                    logError($translate.instant('ErroreElaborazioneRichiesta'));
            });
        }

        $scope.rifiutaAmicizia = function () {
            datacontext.community_rifiutaAmicizia($scope.amicizia.Id).then(function (data) {
                if (data && data.Id) {
                    logSuccess($translate.instant('AmiciziaRifiutata'));
                    $scope.amicizia = data;
                    $uibModalInstance.close();

                    $rootScope.richiesteCount = 0;
                    datacontext.community_getAllRichieste(0).then(function (data) {
                        $rootScope.richiesteCount = data.length;
                    });
                }
                else
                    logError($translate.instant('ErroreElaborazioneRichiesta'));
            });
        }

        $scope.cancellaAmicizia = function () {
            datacontext.community_deleteAmicizia($scope.amicizia.Id).then(function (data) {
                if (data == '200') {
                    logSuccess($translate.instant('AmiciziaCancellata'));
                    $scope.amicizia = null;
                    $uibModalInstance.close();
                }
                else
                    logError($translate.instant('ErroreElaborazioneRichiesta'));
            });
        }

        $scope.cancel = function () {
            $uibModalInstance.dismiss();
        };
    }
})();